/** Canonical Kenyan mobile: +254 then 9 digits starting with 7 or 1. */

export const KENYA_PHONE_PREFIX = "+254";
export const KENYA_PHONE_REGEX = /^\+254[17]\d{8}$/;
export const KENYA_PHONE_HINT =
  "Enter 9 digits after +254 (e.g. 712345678)";
export const KENYA_PHONE_ERROR =
  "Enter a valid Kenyan number: +254 followed by 9 digits starting with 7 or 1";
export const KENYA_PHONE_PLACEHOLDER = "+254712345678";

/** Strip spaces/dashes; normalize 07… / 01… / 254… to +254… */
export function normalizeKenyanPhone(phone) {
  if (phone == null) return "";
  let cleaned = String(phone).replace(/[^\d+]/g, "");

  if (cleaned.startsWith("00")) cleaned = `+${cleaned.slice(2)}`;
  if (cleaned.startsWith("254") && !cleaned.startsWith("+")) {
    cleaned = `+${cleaned}`;
  }
  if (/^0[17]\d{8}$/.test(cleaned)) {
    cleaned = `+254${cleaned.slice(1)}`;
  }

  return cleaned;
}

/** True only for canonical +2547… / +2541… (after normalize). */
export function isValidKenyanPhone(phone) {
  return KENYA_PHONE_REGEX.test(normalizeKenyanPhone(phone));
}

/** Lock +254 in inputs; keep max 13 chars (+254 + 9 digits). Accepts paste of 07… */
export function formatPhoneWithPrefix(value) {
  const prefix = KENYA_PHONE_PREFIX;
  if (!value) return prefix;

  let cleaned = String(value).replace(/[^\d+]/g, "");
  if (!cleaned.startsWith("+") && cleaned.startsWith("254")) {
    cleaned = `+${cleaned}`;
  }
  if (cleaned.startsWith("0")) {
    cleaned = prefix + cleaned.slice(1);
  }
  if (!cleaned.startsWith(prefix)) {
    const digits = cleaned.replace(/\D/g, "").replace(/^254/, "");
    cleaned = prefix + digits;
  }
  if (cleaned.length > 13) cleaned = cleaned.substring(0, 13);
  return cleaned;
}

/** Build a toast-friendly message from API 422 validation errors */
export function formatApiValidationError(err, fallback = "Validation failed") {
  const data = err?.response?.data || err?.data || err;
  const errors = data?.errors;
  if (Array.isArray(errors) && errors.length > 0) {
    return errors
      .map((e) => e.message || (e.field ? `${e.field} is invalid` : null))
      .filter(Boolean)
      .join(". ");
  }
  return data?.message || fallback;
}
